import React from "react";
import overrides from "../../../../css/customization.scss";
import Icon from "../../../../svgs/Star";
import Goal from "../../../../svgs/Goal";
import { formatMatches } from "../../../utils/format-matches";

import styles from "./left-right-panel.module.scss";

const LeftRightPanel = ({
    TOTAL_TIME_PLAYED,
    quarterSelected,
    setEventDetailsToAdd,
    EVENT_TYPES,
    setIsModalOpen,
    sideSelected,
    sideNotSelected,
    sides,
    backgroundColor,
    direction,
    goals,
    setGoals,
    setIsEditing,
    setComponentToInsertInModal,
    matchStatus,
    matchData,
}) => {
    //check if shootout is active
    const { quarter4, matchHasShootout, matchPosts, formatObject } = matchData;
    const penaltyEvent = matchPosts?.some(
        (post) => post.additionalData === "Start of a shootout"
    );
    const isShootout = quarter4 && matchHasShootout && penaltyEvent;
    const format = formatObject;
    const periodAbbreviation = format?.periodAbbreviation;
    const realPeriod = isShootout
        ? "SO"
        : periodAbbreviation +
          quarterSelected.substr(quarterSelected.length - 1);

    const onClick = (et, psEventActive, pcEventActive) => {
        if (et?.addComponentToOpen) {
            setComponentToInsertInModal(et?.addComponentToOpen);
            setIsEditing(false);

            const commonEventDetails = {
                type: et,
                timestamp: TOTAL_TIME_PLAYED,
                quarterSelected,
                sideSelected,
                sideNotSelected,
                liveEvent: true,
                realPeriod,
            };

            if (isShootout) {
                const [quarter, minutes] = formatMatches(format);
                const gameInTotal = quarter * (minutes * 60);
                commonEventDetails.timestamp = gameInTotal;
            }

            if (et?.name === "GOAL" && !psEventActive && !pcEventActive) {
                setGoals((data) => ({
                    ...data,
                    [sideSelected?.side]: data[sideSelected?.side] + 1,
                }));

                setEventDetailsToAdd({
                    ...commonEventDetails,
                    [sideSelected?.side]: {
                        ...sideSelected,
                        goals: !isShootout
                            ? goals[sideSelected?.side] + 1
                            : goals[sideSelected?.side],
                    },
                    [sideNotSelected?.side]: {
                        ...sideNotSelected,
                        goals: goals[sideNotSelected?.side],
                    },
                });
            } else {
                setEventDetailsToAdd({
                    ...commonEventDetails,
                    [sideSelected?.side]: {
                        ...sideSelected,
                        goals: goals[sideSelected?.side],
                    },
                    [sideNotSelected?.side]: {
                        ...sideNotSelected,
                        goals: goals[sideNotSelected?.side],
                    },
                });
            }
            setIsModalOpen(true);
        }

        return () => {};
    };
    const penaltyShootActive = matchData.matchPosts?.length
        ? matchData.matchPosts[matchData.matchPosts.length - 1].postType === 32
        : false;
    const psEventActive = matchData.matchPosts?.length
        ? matchData.matchPosts[matchData.matchPosts.length - 1].postType === 14
        : false;
    const pcEventActive = matchData.matchPosts?.length
        ? matchData.matchPosts[matchData.matchPosts.length - 1].postType === 26
        : false;
    let psEventTeam = "";

    if (psEventActive || pcEventActive) {
        psEventTeam =
            matchData.matchPosts[matchData.matchPosts.length - 1].team;
    }

    return (
        <div
            className={styles["panel"]}
            style={{
                backgroundColor: backgroundColor,
                ...(matchStatus > 3 ||
                matchData.status === 2 ||
                penaltyShootActive ||
                !Object.keys(sides).length
                    ? { opacity: "0.3", pointerEvents: "none" }
                    : {}),
            }}
        >
            <h3 className={`${overrides.fontRoboto} ${styles["panel__title"]}`}>
                <Icon />
                <span style={{ marginLeft: "5px" }}>Aktionen</span>
            </h3>
            <div
                className={styles["panel__buttons"]}
                style={{
                    flexDirection: direction,
                }}
            >
                {EVENT_TYPES?.slice(0, 4)?.map((et, index) => {
                    return (
                        <button
                            key={index}
                            className={styles["panel__button"]}
                            style={{
                                background: et?.background,
                                ...(et?.name !== "GOAL" && isShootout
                                    ? { opacity: "0.3", pointerEvents: "none" }
                                    : {}),
                                ...(et?.name !== "GOAL" &&
                                (psEventActive || pcEventActive)
                                    ? { opacity: "0.3", pointerEvents: "none" }
                                    : {}),
                                ...(et?.name === "GOAL" &&
                                (psEventActive || pcEventActive) &&
                                psEventTeam !== sideSelected?.id
                                    ? { opacity: "0.3", pointerEvents: "none" }
                                    : {}),
                            }}
                            onClick={() =>
                                onClick(et, psEventActive, pcEventActive)
                            }
                        >
                            {et?.name === "GOAL" && (
                                <Goal style={{ marginRight: "20px" }} />
                            )}
                            {et?.name === "GOAL" && isShootout
                                ? "PENALTY"
                                : et?.name === "GOAL" &&
                                  (psEventActive || pcEventActive)
                                ? "GOAL / MISS"
                                : et?.name}
                        </button>
                    );
                })}
            </div>
            <div
                className={styles["panel__penalties"]}
                style={{
                    flexDirection: direction,
                }}
            >
                {EVENT_TYPES?.slice(4, 6)?.map((et, index) => {
                    return (
                        <button
                            key={index}
                            className={styles["panel__button"]}
                            style={{
                                background: et?.background,
                                ...(isShootout
                                    ? { opacity: "0.3", pointerEvents: "none" }
                                    : {}),
                                ...(psEventActive
                                    ? { opacity: "0.3", pointerEvents: "none" }
                                    : {}),
                                ...(pcEventActive
                                    ? { opacity: "0.3", pointerEvents: "none" }
                                    : {}),
                            }}
                            onClick={() => onClick(et)}
                        >
                            {et?.name}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default LeftRightPanel;
